import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { style, styleVariants } from '../layer.css';

export const textareaVariants = styleVariants({
  default: {
    outline: `1px solid ${themeVars.controls.border.default}`,
  },
  error: {
    outline: `1px solid ${themeVars.controls.border.critical}`,
  },
});

export const textareaContainer = style({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: borderRadius.r12,
  maxHeight: '220px',
  outlineOffset: '-1px',

  ':hover': {
    outlineColor: themeVars.controls.border.hover,
  },
  ':focus-within': {
    outlineColor: themeVars.controls.border.active,
  },

  selectors: {
    '&:has(textarea:disabled)': {
      pointerEvents: 'none',
      backgroundColor: themeVars.controls.background.disabled,
      color: themeVars.controls.foreground.disabled,
      outline: 'none',
    },
  },
});

export const textarea = style({
  ...typography['bodyMd'],
  padding: `${space.s12}px ${space.s16}px`,
  scrollbarGutter: 'stable',
  resize: 'none',
  border: 'none',
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  outline: 'none',
  backgroundColor: themeVars.controls.background.default,

  '::placeholder': {
    color: themeVars.controls.foreground.default,
  },
});
